(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fineps-category-mosaic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fineps-category-slider')) {
    class FinepsCategorySlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-slider-track]');
        this.viewport = this.querySelector('[data-slider-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-target]'));
        this.status = this.querySelector('[data-slider-status]');
        this.currentIndex = 0;
        this.pointerStart = null;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplaySpeed = Math.max(3, Number(this.dataset.speed) || 6) * 1000;
        this.pageHidden = document.hidden;
        this.inViewport = true;

        if (!this.track || this.slides.length < 2) return;

        this.querySelector('[data-slider-previous]')?.addEventListener('click', () => {
          this.goTo(this.currentIndex - 1, true);
        });

        this.querySelector('[data-slider-next]')?.addEventListener('click', () => {
          this.goTo(this.currentIndex + 1, true);
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.slideTarget), true);
          });
        });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1, true);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1, true);
          }
        });

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.isPrimary) this.pointerStart = event.clientX;
        });

        this.viewport.addEventListener('pointerup', (event) => {
          if (this.pointerStart === null || !event.isPrimary) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;

          if (Math.abs(distance) < 42) return;
          this.goTo(distance > 0 ? this.currentIndex - 1 : this.currentIndex + 1, true);
        });

        this.handleVisibilityChange = () => {
          this.pageHidden = document.hidden;
          this.scheduleAutoplay();
        };
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inViewport = entries.some((entry) => entry.isIntersecting);
            this.scheduleAutoplay();
          }, { threshold: 0.2 });
          this.observer.observe(this);
        }

        this.update();
        this.scheduleAutoplay();
      }

      disconnectedCallback() {
        window.clearTimeout(this.autoplayTimer);
        this.observer?.disconnect();
        if (this.handleVisibilityChange) {
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
      }

      goTo(index, announce = false) {
        const slideCount = this.slides.length;
        this.currentIndex = (index + slideCount) % slideCount;
        this.update(announce);
        this.scheduleAutoplay();
      }

      scheduleAutoplay() {
        window.clearTimeout(this.autoplayTimer);

        const canPlay = this.autoplayEnabled
          && !this.pageHidden
          && this.inViewport;

        if (!canPlay) return;

        this.autoplayTimer = window.setTimeout(() => {
          this.goTo(this.currentIndex + 1, false);
        }, this.autoplaySpeed);
      }

      update(announce = false) {
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

        this.slides.forEach((slide, index) => {
          const isCurrent = index === this.currentIndex;
          slide.setAttribute('aria-hidden', String(!isCurrent));
          slide.inert = !isCurrent;
        });

        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.currentIndex));
        });

        if (this.status) {
          this.status.setAttribute('aria-live', announce ? 'polite' : 'off');
          this.status.textContent = `${this.dataset.slideLabel} ${this.currentIndex + 1} ${this.dataset.ofLabel} ${this.slides.length}`;
        }
      }
    }

    customElements.define('fineps-category-slider', FinepsCategorySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
